export default __webpack_public_path__ + "static/media/icon-dot-gov.2dda0fdb.svg";